<template>
  <div>
    <div class="bg-gray-100 w-full h-full absolute" style="z-index: -10"></div>
    <div class="text-center p-16" v-if="isLoadingBookings">
      <p class="opacity-60">Finding bookings</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <div class="mt-5 max-w-screen-lg w-full mx-auto" v-if="!isLoadingBookings">
      <hr
        class="mb-2 mt-4 mr-8"
        style="
          border-top: 2px dotted #e3e3e3;
          border-bottom: none;
          border-left: none;
          border-right: none;
        "
      />
      <div class="flex my-4">
        <div class="flex">
          <p class="text-grey mr-3 my-auto">Choose date:</p>

          <DatePicker locale="en" :first-day-of-week="1"
            :attributes="calendarAttributes"
            v-model="dpDate"
            @dayclick="handleDayClick($event)"
            @update:from-page="handleCalendarPageChange($event)"
            @update:to-page="handleCalendarPageChange($event)"
          >
            <template v-slot="{ togglePopover }">
              <vs-input readonly :value="moment(dpDate).format('DD-MM-YYYY')" @click="togglePopover" />
            </template>
          </DatePicker>
        </div>
        <p class="ml-8 text-grey mr-3 my-auto">Pre orders:</p>
        <vs-button
          class="btn btn-primary"
          @click="$refs.popupAllPreorders.show(selectedDate, enhancedBookings)"
        >
          See all pre orders
        </vs-button>
      </div>

      <hr
        class="mb-2 mt-4 mr-8"
        style="
          border-top: 2px dotted #e3e3e3;
          border-bottom: none;
          border-left: none;
          border-right: none;
        "
      />

      <div class="mt-8">
        <div
          style="
            background-color: rgb(255 212 134) !important;
            color: rgb(139 93 10) !important;
          "
          v-for="venueNote in venueNotes"
          :key="venueNote.id"
          class="
            bg-warning bg-yellow-100
            opacity-80
            p-4
            rounded
            mb-2
            text-yellow-900 text-sm
            shadow-lg
          "
        >
          <p>
            <span class="font-bold">
              {{ formatVenueNoteDate(venueNote) }}
            </span>
            - {{ getUserName(venueNote) }}
          </p>
          <p><pre>{{ venueNote.message }}</pre></p>
        </div>

        <div>
          <p class="my-auto mb-2 text-grey" v-if="venueNotes.length < 1">
            <small>No notes for this night</small>
          </p>
          <vs-button
            class="btn btn-primary"
            @click="$refs.popupAddVenueNote.show(selectedDate)"
          >
            Add a note
          </vs-button>
          <vs-button
            class="ml-2"
            :color="isOnlineBookingClosed ? 'success' : 'danger'"
            @click="$refs.popupStopBookings.show(selectedDate)"
          >
            {{ isOnlineBookingClosed ? 'Start' : 'Stop' }} online bookings
          </vs-button>
        </div>
      </div>
      <div
        class="
          bg-primary
          p-4
          rounded
          mt-4
          text-white
          shadow-lg
          flex
          justify-between
        "
      >
        <div>
          <p><span class="font-bold">Guestlist</span></p>
          <p>
            {{ numGuestsInGuestList }} guests in
            {{ numItemsInGuestList }} entries on the guest list
          </p>
        </div>
        <div class="flex">
          <div class="flex my-auto">
            <vs-button
              class="btn btn-primary"
              size="small"
              v-if="
                hasPermissionForActiveVenue(
                  'vp.vp.booking.addtoguestlist'
                )
              "
              @click="$refs.popupAddGuestListItem.show(selectedDate)"
            >
              Add guest
            </vs-button>
            <vs-button
              class="btn btn-primary ml-2"
              size="small"
              v-if="
                hasPermissionForActiveVenue(
                  'vp.vp.booking.viewguestlist'
                )
              "
              @click="$refs.popupViewGuestListItems.show(selectedDate)"
            >
              View list
            </vs-button>
          </div>
        </div>
      </div>
      <div class="border border-gray-200 mt-6 mb-6"></div>
      <vs-row class="text-sm text-gray-500" vs-justify="space-between">
        <vs-col vs-lg="7" vs-sm="6" vs-xs="12">
          <vs-row>
          Total table reservation:
          {{ enhancedBookings ? enhancedBookings.length : 0 }} - Total guests
          {{ totalGuests() }} - Table occupancy rate: {{ Math.round(bookingPercentageBySelectedDate ? bookingPercentageBySelectedDate : bookingPercentageBySelectedDate) }}%
          </vs-row>
          <vs-row vs-align="center" v-if="enhancedBookingsOnDeactivatedTables && enhancedBookingsOnDeactivatedTables.length > 0">
            <feather-icon icon="AlertTriangleIcon" svgClasses="text-danger" />
            <span>SOME BOOKINGS HAVE INACTIVE TABLES: {{enhancedBookingsOnDeactivatedTables.length}}</span>
          </vs-row>
          <vs-row v-if="enhancedBookingsOnDeactivatedTables && enhancedBookingsOnDeactivatedTables.length > 0">
            <vs-button color="warning" @click="$refs.popupViewBookingsOnDeactivatedTables.show()">See bookings with inactive tables</vs-button>
          </vs-row>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="flex-end" class="w-full flex-wrap md:flex-nowrap">
          <div class="flex mr-3 items-center" >
             <label class="mr-2">Floorplan</label>
             <vs-switch v-model="floorplan" />
         </div>
          <div class="mr-0 md:mr-2">
            <vs-button
              :disabled="!enhancedBookings || enhancedBookings.length === 0"
              type="border" @click="handlePrintBookingsClick" icon="print">Print bookings</vs-button>
            <a ref="downloadReservationsPdfLink" :vs-show="false" :href="reservationsPdfUrl" download="reservations.pdf" />
          </div>
          <div class="flex w-full md:w-auto mt-2 md:mt-0 ">
            <div class="mr-2 ml-auto">
              <vs-button
                v-if="hasPermissionForActiveVenue('vp.vp.booking.createbookings')"
                @click="handleAddWalkInClick">Add Walk-in</vs-button>
            </div>
            <div >
              <vs-button
                v-if="hasPermissionForActiveVenue('vp.vp.booking.createbookings')"
                @click="handleAddBookingClick">Add booking</vs-button>
            </div>
          </div>
        </vs-col>
      </vs-row>

      <div v-if="floorplan" class="mt-4" >
        <div
          v-if="!loadingFloorplan"
          class="relative"
          style="height: 600px; border: solid 1px #dddddd"
        >
          <floorplan-canvas
            :leftOffset="180"
            ref="floorplancanvas"
            @onBookingClick="$refs.popupEditBooking.show($event)"
            @onTableClick="
              $refs.popupTableDetails.show($event, handleAddBookingClick)
            "
          ></floorplan-canvas>
          <div
            class="shadow-lg p-4 rounded absolute overflow-auto"
            style="
              top: 8px;
              left: 8px;
              background: white;
              bottom: 8px;
              width: 13rem;
              font-size: 85%;
            "
            v-if="this.setup.venueSections"
          >
            <h6>Tables</h6>
            <p class="text-grey leading-relaxed mb-2" style="line-height: 1">
              <small>Click element to find it on floorplan</small>
            </p>
            <div
              v-for="(section, index) of this.setup.venueSections"
              :key="index"
              class="mb-4"
            >
              <h6
                class="mt-auto mr-8 cursor-pointer mb-1"
                @click="searchSection(section.id)"
              >
                {{ section.name }}
              </h6>
              <div
                style="
                  border-bottom: 1px solid #f3f3f3;
                  margin-bottom: 0.5rem;
                  margin-top: 0.25rem;
                "
              ></div>
              <div
                v-for="(table, index) of section.venueTables"
                :key="'table' + index"
                class="mb-2 py-1 px-2 rounded"
                :style="{
                  background:
                    table.booking ? '#ad0b0b1f' : 'inherit',
                }"
              >
                <div class="flex justify-between">
                  <p>
                    <span
                      class="cursor-pointer"
                      @click="searchTable(table.id)"
                      >{{ table.name }}</span
                    >
                    <feather-icon
                      v-if="table.isPlaced"
                      :icon="'CheckIcon'"
                      class="text-primary ml-4"
                      svgClasses="h-4 w-4 my-auto"
                    >
                    </feather-icon>
                  </p>
                  <div>
                    <p
                      class="cursor-pointer"
                      @click="$refs.popupEditBooking.show(table.booking)"
                      v-if="table.booking"
                    >
                      <small>Booked</small>
                    </p>
                    <p
                      class="cursor-pointer"
                      @click="
                        $refs.popupTableDetails.show(
                          table,
                          handleAddBookingClick
                        )
                      "
                      v-else
                    >
                      <small>{{
                        table.isReservedForWalkIns() ? "Walk-in" : "Available"
                      }}</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loadingFloorplan">
          <p class="opacity-60">Loading floorplan</p>
          <span class="flex h-12 w-12 mx-auto mt-5">
            <span
              class="
                animate-ping
                absolute
                inline-flex
                h-12
                w-12
                rounded-full
                bg-primary
                opacity-75
              "
            ></span>
            <span
              class="relative inline-flex rounded-full h-12 w-12 bg-primary"
            ></span>
          </span>
        </div>
      </div>

      <div class="mt-4" v-if="!floorplan">
        <div v-for="event in events" :key="event.eventId.id" style="background:#efefef" class="p-4 rounded mb-2">
          <p style="color:#a3a3a3"><small>Event | {{formattedTime(event.eventStart)}} - {{formattedTime(event.eventEnd)}}</small></p>
          <h5>{{event.eventName}}</h5>

          <div>
            <div v-if="getEventBookings(event.eventId).length === 0">
              <p style="color:#a3a3a3"><small>No bookings on this event</small></p>
            </div>
            <div class="mt-3" v-else>
              <div
                v-for="eventBooking in getEventBookings(event.eventId)"
                :key="eventBooking.booking.id"
                @click="$refs.popupEditBooking.show(eventBooking)"
                class="bg-white shadow-lg mb-4 p-4 px-6 rounded-lg cursor-pointer"
              >
                <booking-list-item
                  :enhanced-booking="eventBooking"
                  :show-actions="true"
                  @booking-updated="searchBookings()"
                ></booking-list-item>
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="enhBooking in sortAfterEnded(regularBookings)"
          :key="enhBooking.booking.id"
          @click="$refs.popupEditBooking.show(enhBooking)"
          class="bg-white shadow-lg mb-4 p-4 px-6 rounded-lg cursor-pointer"
        >
          <booking-list-item
            :enhanced-booking="enhBooking"
            :show-actions="true"
            @booking-updated="searchBookings()"
          ></booking-list-item>
        </div>
      </div>
    </div>

    <popup-add-booking
      ref="popupAddBooking"
      :venue-details="activeVenueDetails"
      @booking-created="handleBookingCreated"
    />
    <popup-edit-booking
      ref="popupEditBooking"
      :venue-details="activeVenueDetails"
      @booking-updated="handleBookingUpdated"
    />

    <popup-table-details
      @viewEndedBooking="$refs.popupEditBooking.show($event)"
      ref="popupTableDetails"
    />
    <popup-add-venue-note ref="popupAddVenueNote" />
    <popup-stop-bookings ref="popupStopBookings" />
    <popup-add-guest-list-item ref="popupAddGuestListItem" />
    <popup-view-guest-list-items ref="popupViewGuestListItems" />
    <popup-all-preorders ref="popupAllPreorders" />
    <popup-view-bookings-on-deactivated-tables ref="popupViewBookingsOnDeactivatedTables"
      :popup-edit-booking="$refs.popupEditBooking" />
  </div>
</template>

<script>
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";

import { mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import { DatePicker } from "v-calendar";
import PopupAddBooking from "../popups/PopupAddBooking.vue";
import PopupEditBooking from "../popups/PopupEditBooking.vue";
import PopupAddVenueNote from "../popups/PopupAddVenueNote.vue";
import PopupStopBookings from "../popups/PopupStopBookings.vue";
import PopupAddGuestListItem from "../popups/PopupAddGuestListItem.vue";
import PopupViewGuestListItems from "../popups/PopupViewGuestListItems.vue";
import PopupAllPreorders from "../popups/PopupAllPreorders.vue";
import PopupViewBookingsOnDeactivatedTables from "../popups/PopupViewBookingsOnDeactivatedTables.vue";
import { BookingsByDateQuery } from "@/store/modules/marcom/data-model/bookings/queries-and-commands/bookings-by-date-query.js";
import moment from "moment";
import BookingListItem from "../components/BookingListItem.vue";
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import { GetGuestListItemsQuery } from "@/store/modules/marcom/data-model/guest-list-items/queries-and-commands/get-guest-list-items-query";
import { GetVenueNotesQuery } from "@/store/modules/marcom/data-model/venue-notes/queries-and-commands/get-venue-notes-query";
import FloorplanCanvas from "../../marcom/components/FloorplanCanvas.vue";
import PopupTableDetails from "../../marcom/popups/PopupTableDetails.vue";
import { BOOKING_TYPE_TAG } from "../../../../store/modules/marcom/data-model/bookings";

export default {
  components: {
    flatPickr,
    DatePicker,
    FloorplanCanvas,
    PopupTableDetails,
    PopupAddBooking,
    PopupEditBooking,
    PopupAddVenueNote,
    PopupStopBookings,
    PopupAddGuestListItem,
    PopupViewGuestListItems,
    PopupAllPreorders,
    PopupViewBookingsOnDeactivatedTables,
    BookingListItem,
    FeatherIcon,
  },
  data() {
    return {
      moment,
      bookingPercentageBySelectedDate: 0,
      selectedDate: moment(),
      pFloorplan: false,
      loadingFloorplan: false,
      setup: undefined,
      //night: "",
      dpDate: new Date(),
      // datePickerConfigStart: {
      //   enableTime: false, // Set to true for time again
      //   enableSeconds: false,
      //   noCalendar: false,
      //   time_24hr: true,
      //   dateFormat: "d-m-Y", // "d-m-Y H:i" for time,
      // },

      isLoadingEvents: false,
      events: null,
      reservationsPdfUrl: undefined,
      bookingPercentageByVenue: [],
    };
  },

  async mounted() {
    this.selectedDate = moment();
    //this.night = this.selectedDate.format("DD-MM-YYYY");

    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.FindActiveVenue, {
      venuePortalId: this.activeVenue.venueId,
    });

    // let unsubscribe = this.$store.subscribe(async (mutation, state) => {
    //   var type = "marcom/" + VENUE_MUTATIONS.GotActiveVenue;
    //   if (mutation.type === type) {
    //     if (this.activeVenueDetails) {
    //       unsubscribe();
    //       await this.loadData();
    //     }
    //   }
    // });

    await this.loadData();
    this.searchFloorplan();
  },

  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
      isOnlineBookingClosed: "marcom/isOnlineBookingClosed",
      isLoadingActiveVenue: "marcom/isLoadingActiveVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
      enhancedBookings: "marcomBooking/enhancedBookings",
      user: "users/user",
      enhancedBookingsOnDeactivatedTables:
        "marcomBooking/enhancedBookingsOnDeactivatedTables",
    }),
    isLoadingBookings() {
      return this.$store.state.marcomBooking.isLoadingBookings;
    },
    floorplan: {
      // getter
      get: function () {
        return this.pFloorplan;
      },
      // setter
      set: async function (newValue) {
        this.pFloorplan = newValue;
        if (newValue) {
          this.searchFloorplan();
        }
      },
    },

    numGuestsInGuestList() {
      let count = this.$store.state.marcom.guestListItems.reduce(
        (previousCount, guestListItem) => {
          return previousCount + guestListItem.guestCount;
        },
        0
      );
      return count;
    },
    numItemsInGuestList() {
      return this.$store.state.marcom.guestListItems.length;
    },

    venueNotes() {
      return this.$store.state.marcom.venueNotes;
    },
    regularBookings() {
      return this.enhancedBookings.filter((b) => b.booking.eventId == null);
    },
    calendarAttributes() {
      return [
        {
          key: "today",
          highlight: "gray",
          dates: new Date(),
        },
        {
          key: "sold-out",
          highlight: "red",
          popover: {
            label: "Sold out",
          },
          dates: this.bookingPercentageByVenue
            .filter((bp) => bp.bookingPercent >= 100)
            .map((bp) => new Date(bp.date)),
        },
      ];
    },
  },
  methods: {
    async loadData() {
      await this.searchBookings();
      await this.getVenueNotes();
      await this.getGuestListItems();
      await this.getBookingPercentagesByDate();

      await this.getBookingPercentages(
        this.selectedDate.year(),
        this.selectedDate.month()
      );
    },
    getUserName(venueNote) {
      const theUser = this.user(venueNote.createdBy.id);
      return theUser
        ? `${theUser.firstName} ${theUser.lastName}`
        : "Unknown user";
    },
    async searchBookings() {
      if (!this.activeVenueDetails) return;
      var bookingQuery = BookingsByDateQuery.create(
        this.selectedDate,
        this.activeVenueDetails
      );

      this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.SearchBookings,
        bookingQuery
      );
      this.isLoadingEvents = true;
      this.events = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetEventsByDate,
        bookingQuery
      );
      this.isLoadingEvents = false;
    },
    async getBookingsOnDeactivatedTables() {
      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.GetBookingsOnDeactivatedTables,
        this.activeVenueDetails.venueDetailsId
      );
    },
    async getVenueNotes() {
      if (!this.activeVenueDetails) return;
      let query = new GetVenueNotesQuery(
        this.selectedDate,
        this.activeVenueDetails.venueDetailsId
      );

      return this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetVenueNotes,
        query
      );
    },

    async getGuestListItems() {
      if (!this.activeVenueDetails) return;
      let query = new GetGuestListItemsQuery(
        this.selectedDate,
        this.activeVenueDetails.venueDetailsId
      );

      return this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetGuestListItems,
        query
      );
    },

    async dateSelected(date) {
      this.selectedDate = moment(date); //[0]);
      //this.night = this.selectedDate.format("DD-MM-YYYY");
      if (this.activeVenueDetails) {
        await this.loadData();
      }
    },

    totalGuests() {
      var tot = 0;

      if (this.enhancedBookings)
        this.enhancedBookings.forEach((b) => (tot += b.booking.guestCount));

      return tot;
    },

    addGuestListItem() {
      if (this.$refs.guestList == null) {
        this.toggleGuestList(true);
      }

      setTimeout(() => {
        this.$refs.guestList.openAddGuestListItemDialog();
      }, 1);
    },

    formatVenueNoteDate(venueNote) {
      let noteMoment = moment.utc(venueNote.date);
      return noteMoment.format("DD-MM-YYYY");
    },
    async handleBookingUpdated() {
      await this.searchBookings();
    },
    handleAddBookingClick() {
      const isWalkIn = false;
      let date = this.selectedDate.hours(22).minutes(0).toJSON();
      this.$refs.popupAddBooking.show(isWalkIn, date);
    },
    handleAddWalkInClick() {
      const isWalkIn = true;
      let date = this.selectedDate.hours(22).minutes(0).toJSON();
      this.$refs.popupAddBooking.show(isWalkIn, date);
    },
    async handleBookingCreated() {
      await this.searchBookings();
    },
    getEventBookings(eventId) {
      if (this.enhancedBookings) {
        var ret = this.enhancedBookings.filter(
          (b) =>
            b.booking.eventId != null &&
            b.booking.eventId != undefined &&
            b.booking.eventId.id == eventId.id
        );
        return ret;
      }
      return [];
    },
    formattedTime(time) {
      return moment(time).format("HH:mm");
    },
    async handlePrintBookingsClick() {
      try {
        this.$vs.loading();
        const bookingIds = this.enhancedBookings.map(
          (enh) => enh.booking.bookingId
        );
        const pdfData = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.PostCreateReservationsPdf,
          bookingIds
        );

        this.reservationsPdfUrl = window.URL.createObjectURL(
          new Blob([pdfData])
        );

        setTimeout(() => {
          this.$refs.downloadReservationsPdfLink.click();
        }, 150);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Failed getting reservations pdf",
          text: "Could not create reservations pdf",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getBookingPercentagesByDate() {
      const mDate = this.selectedDate; //moment(this.pDate);

      var result = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetBookingPercentageByDateAndVenueDetailIds,
        {
          date: mDate.format("YYYY-MM-DD"),
          venueDetailsIds: [this.activeVenueDetails.venueDetailsId],
        }
      );

      this.bookingPercentageBySelectedDate = result[0].bookingPercent;
    },
    async getBookingPercentages(year, month) {
      //const mDate = moment(this.dpDate);

      this.bookingPercentageByVenue = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetBookingPercentageMonth,
        {
          venueDetailsId: this.activeVenueDetails.venueDetailsId,
          year: year,
          month: month,
        }
      );
    },
    handleDayClick(eventObj) {
      this.dateSelected(eventObj.date);
    },
    async handleCalendarPageChange(eventObj) {
      await this.getBookingPercentages(eventObj.year, eventObj.month);
    },
    sortAfterEnded(bookings) {
      return bookings.sort((a, b) => {
        var atags = a.booking.tags.filter((x) => x == "BOOKING_TYPE:ENDED");
        var btags = b.booking.tags.filter((y) => y == "BOOKING_TYPE:ENDED");
        return atags.length - btags.length;
      });
    },

    async searchFloorplan() {
      if (this.floorplan) {
        this.loadingFloorplan = true;

        var setupQuery = {
          venueDetailsId: this.activeVenueDetails.id,
          dateTime: moment(this.dpDate).hours(22).minutes(0).toJSON(),
        };

        this.setup = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.GetActiveSetup,
          setupQuery
        );

        console.log("SETUP", this.setup);
        if (this.setup) {
          var result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.GetFloorplan,
            this.setup.id
          );
          if (this.isFloorPlanAvailable(result)) {
            var setupTables = this.setup.venueSections
              .map((s) => s.venueTables)
              .flat();

            for (const table of result.tables) {
              var setupTable = setupTables.find((st) => st.id == table.tableId);
              if (setupTable) {
                table.name = setupTable.name;
                table.note = setupTable.note;
                table.isRoundTable = setupTable.isRoundTable;
                table.seatCount = setupTable.seatCount;
                table.isReservedForWalkIns = setupTable.isReservedForWalkIns();
                table.isActive = setupTable.isActive;
              }

              const allBookingsForTable = this.enhancedBookings.filter(
                (b) =>
                  b.reservedTable.id === table.tableId ||
                  (b.reservedTable.combinationTablePartIds !== null &&
                    b.reservedTable.combinationTablePartIds.filter(
                      (rt) => rt === table.tableId
                    ).length > 0)
              );

              table.booking = allBookingsForTable[0];

              const endedBookings = allBookingsForTable.filter(
                (b) =>
                  b.booking.tags.filter((tag) => tag == BOOKING_TYPE_TAG.Ended)
                    .length > 0
              );

              if (table.booking) {
                table.discardedBooking =
                  endedBookings[endedBookings.length - 1];

                if (allBookingsForTable.length > endedBookings.length) {
                  table.booking = allBookingsForTable.find(
                    (b) =>
                      b.booking.tags.filter(
                        (tag) => tag == BOOKING_TYPE_TAG.Ended
                      ).length == 0
                  );
                } else {
                  table.booking = null;
                }
              }

              setupTable.booking = table.booking;
            }

            var self = this;
            setTimeout(() => {
              self.$refs.floorplancanvas.setFloorplanModel(result);
            }, 100);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Wait",
              text: "No setup found for this date",
            });
          }
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Wait",
            text: "No setup found for this date",
          });
          this.floorplan = false;
        }

        this.loadingFloorplan = false;
      }
    },

    isFloorPlanAvailable(setup) {
      return (
        setup.tables.filter((t) => {
          return t.itemType != "NullTable";
        }).length > 0
      );
    },
    searchSection(sectionId) {
      this.$refs.floorplancanvas.zoomToSection(sectionId);
    },
    searchTable(tableId) {
      this.$refs.floorplancanvas.zoomToTable(tableId);
    },
  },
  watch: {
    dpDate() {
      this.floorplan = false;
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  border-top: 2px dotted #d2d2d2;
}
.payment-confirmed-icon svg {
  stroke: #00891b;
  background: #e2e2e2de;
  border-radius: 50%;
  padding: 2px;
}
</style>
